import { axiosRequest } from './axios'

export class ClientServices {
  private static instance: ClientServices;

  private constructor() { }

  public static getInstance(): ClientServices {
    if (!ClientServices.instance) {
      ClientServices.instance = new ClientServices();
    }
    return ClientServices.instance;
  }

  async postConsultaEmail(body: any) {
    const { data } = await axiosRequest.post<any>(`/landingInfo`, body);
    return data;
  }

}